import request from '@/utils/request'

// 查询面积价格分页
export function pageAreaPrice(params) {
  return request({
    url: '/cloudplant/areaPrice/page',
    method: 'post',
    params: params
  })
}

// 查询面积价格列表
export function listAreaPrice(query) {
  return request({
    url: '/cloudplant/areaPrice/list',
    method: 'get',
    params: query
  })
}

// 新增面积价格
export function addAreaPrice(data) {
  return request({
    url: '/cloudplant/areaPrice/add',
    method: 'post',
    data: data
  })
}

// 修改面积价格
export function updateAreaPrice(data) {
  return request({
    url: '/cloudplant/areaPrice/edit',
    method: 'post',
    data: data
  })
}

// 删除面积价格
export function delAreaPrice(data) {
  return request({
    url: '/cloudplant/areaPrice/delete',
    method: 'post',
    data: data
  })
}
